import { getDateField } from '@lender/utils';
import dayjs from 'dayjs';
import { object } from 'yup';

import { getCommonDateBody, getEasternToday } from 'utils/date';

// MERS takes "today" as the US-Eastern day, and the liquidation date must be before it.
export const getLiquidationMaxDate = () => getEasternToday().subtract(1, 'day');

export const getMersDeactivationDetailsSchema = () =>
  object().shape({
    liquidationDate: getDateField({ isRequired: true })
      .nullable()
      .test(
        'in-the-past',
        'MERS needs a liquidation date before today',
        value => !value || dayjs(value).isBefore(getEasternToday(), 'day'),
      ),
  });

export const buildMersDeactivationDetails = form => ({
  liquidationDate: getCommonDateBody(form.liquidationDate),
});
